import gql from 'graphql-tag'

// Queries

export const getLastDataDate = gql`
query lastData {
  getLastDataDate
}`


export const getAdvisorData = gql`
query advisor ($id: Int!) {
  advisor(id: $id) {
    id
    email
    isAdmin
    name
  }
}
`

export const getAllAdvisors = gql`
  query allAdvisors {
    allAdvisors {
      id
      name
      email
    }
  }`

export const getAdvisorsByQuery = gql`
query getAdvisorsByFilter ($query: String) {
  findAdvisors(nameOrEmail: $query) {
    id
    name
    email
  }
}`

export const getAllPortfolios = gql`
  query allPortfolios {
    allPortfolios {
      client {
        id
        alias
        email
      },
      id
      status
      contractNumber
      createdAt
      version
    }
  }`

export const getPortfoliosByAdvisorId = gql`
  query getPortfoliosByAdvisorId ($advisorId: Int, $query: String) {
    portfoliosByAdvisor(advisorId: $advisorId, aliasOrContractNumber: $query) {
      id
      client {
        id
        alias
        email
      }
      status
      cuttofDate
      contractNumber
      updatedAt
      createdAt
      version
      investmentSet {
        id
        asset {
          id
          name
          assetClass {
            name
            id
          }
          price
        }
        totalAmount
        totalSecurities
      }
    }
  }`

export const getPortfolioById = gql`
query portfolioById($id: Int!) {
  portfolioById(portfolioId: $id) {
    id
    client {
      id
      alias
      email
    }
    advisorComment
    status
    cuttofDate
    contractNumber
    investmentSet {
      id
      asset {
        id
        name
        assetClass {
          name
          id
        }
        price
      }
      totalAmount
      totalSecurities
    }
  }
}`

export const getPortfolioByUrl = gql`
  query getPortfolioByUrl ($hash: String!, $password: String!){
    portfolioAnalysisByUrl(hash: $hash, password: $password) {
      analysisPortfolio {
        portfolioId
        contractNumber
        updatedDataAt
        creationDate
        alias
        labels {
          month
          lastYear
          year1
          year2
          year3
          accum
        }
        totalInvestment
        portfolioProfile
        advisorComment
        portfolioComments {
          id
          comment
        }
        representativePositions {
          assetName
          assetClass
          percentage
          color
        }
        marketInformation {
          name
          monthYield
          accumulatedYield
        }
        fondosRV {
          assetClassId
          marketName
          percentage
          amount
          comments {
            id
          }
          investments {
            assetName
            assetId
            percentage
            amount
            accumulatedYield
            commission
            securities
            price
            instrumentComposition {
              name
              inversionType{
                name
              }
              percentage
            }
            comments {
              comment
            }
            benchmarkComparative {
              assetsData
              benchmarkData
            }
          }
          accumulatedYields
          investmentsYield {
            assetName
            year1
            year2
            year3
            accumulatedYield
          }
          comissions
          benchmarkComparative {
            assetsData
            benchmarkData
          }
        }
        fondosRF {
          assetClassId
          marketName
          percentage
          amount
          comments {
            id
          }
          investments {
            assetName
            assetId
            percentage
            score
            sliderValue {
              value
            }
            amount
            accumulatedYield
            commission
            securities
            price
            investmentYield {
              assetName
              year1
              year2
              year3
              accumulatedYield
            }
            instrumentComposition {
              name
              inversionType{
                name
              }
              percentage
            }
            benchmarkComparative {
              assetsData
              benchmarkData
            }
            comments {
              comment
            }
          }
          accumulatedYields
          investmentsYield {
            assetName
            year1
            year2
            year3
            accumulatedYield
          }
          comissions
          benchmarkComparative {
            assetsData
            benchmarkData
          }
          scoreDistribution {
            name
            percentage
          }
        }
        capitales {
          assetClassId
          marketName
          percentage
          amount
          accumulatedYields
          benchmarkYields
          investments {
            assetName
            assetId
            percentage
            price
            amount
            securities
            completeName
            assetType
            sector
            bursatility
            investmentYield {
              assetName
              initialPrice
              currentPrice
              accumulatedYield
              weightedAccumulatedYield
            }
            comments {
              comment
            }
          }
          investmentsYield {
            assetName
            initialPrice
            currentPrice
            accumulatedYield
            weightedAccumulatedYield
          }
          sectorDistribution {
            name
            percentage
          }
          comments {
            id
          }
        }
        deuda {
          couponData {
            assetName
            frecuency
            tasa
            endData
            ytm
          }
          assetClassId
          marketName
          percentage
          amount
          investments {
            assetName
            assetId
            percentage
            price
            amount
            securities
            assetType
            rateType
            score
            couponData {
              assetName
              tasa
              frecuency
              endData
              ytm
            }
            sliderValue {
              value
            }
            comments {
              comment
            }
          }
          assetTypesDistribution {
            name
            percentage
          }
          assetRateDistribution {
            name
            percentage
          }
          scoreDistribution {
            name
            percentage
          }
          comments {
            comment
          }
        }
        estructurados {
          assetClassId
          marketName
          percentage
          amount
          investments {
            assetName
            assetId
            percentage
            price
            amount
            securities
            assetType
            rateType
            score
          }
          assetTypesDistribution {
            name
            percentage
          }
          assetRateDistribution {
            name
            percentage
          }
          scoreDistribution {
            name
            percentage
          }
          comments {
            comment
          }
        }
      }
      msg
      returnCode
    }
  }`

export const getClientsByAdvisor = gql`
  query clientsByAdvisor ($advisorId: Int!) {
    clientsByAdvisor(advisorId: $advisorId) {
      id
      alias
      email
    }
  }`

export const recoverPassword = gql`
query recoverPassword ($email: String!) {
  recoverPassword (advisorEmail: $email){
    msg
  }
}`

export const getAssetClasses = gql`
  query allAssetClasses {
    allAssetClasses {
      id
      name
    }
  }`

export const getAssets = gql`
  query getAssets ($cuttofDate: Date, $idAssetClass: Int, $startsWith: String) {
    allAssets(cuttofDate: $cuttofDate, idAssetClass: $idAssetClass, startsWith: $startsWith) {
      id
      name
      price
      assetClass {
        id
        name
      }
    }
  }`

export const getPortfolioAnalysis = gql`
  query makePortfolioAnalysis ($id: Int!) {
    portfolioAnalysis(portfolioId: $id) {
      contractNumber
      creationDate
      updatedDataAt
      alias
      email
      labels {
        month
        lastYear
        year1
        year2
        year3
        accum
      }
      totalInvestment
      portfolioProfile
      advisorComment
      portfolioComments {
        id
        comment
      }
      representativePositions {
        assetName
        assetClass
        percentage
        color
      }
      marketInformation {
        name
        monthYield
        accumulatedYield
      }
      fondosRV {
        assetClassId
        marketName
        percentage
        amount
        comments {
          id
          comment
        }
        investments {
          assetName
          assetId
          percentage
          amount
          accumulatedYield
          commission
          securities
          price
          instrumentComposition {
            name
            inversionType{
              name
            }
            percentage
          }
          benchmarkComparative {
            assetsData
            benchmarkData
          }
          comments {
            comment
          }
        }
        accumulatedYields
        investmentsYield {
          assetName
          year1
          year2
          year3
          accumulatedYield
        }
        comissions
        benchmarkComparative {
          assetsData
          benchmarkData
        }
      }
      fondosRF {
        assetClassId
        marketName
        percentage
        amount
        comments {
          id
          comment
        }
        investments {
          assetName
          assetId
          percentage
          amount
          score
          sliderValue {
            value
          }
          investmentYield {
            assetName
            year1
            year2
            year3
            accumulatedYield
          }
          accumulatedYield
          commission
          securities
          price
          instrumentComposition {
            name
            inversionType{
              name
            }
            percentage
          }
          benchmarkComparative {
            assetsData
            benchmarkData
          }
          comments {
            comment
          }
        }
        accumulatedYields
        investmentsYield {
          assetName
          year1
          year2
          year3
          accumulatedYield
        }
        comissions
        benchmarkComparative {
          assetsData
          benchmarkData
        }
        scoreDistribution {
            name
            percentage
        }
      }
      capitales {
        assetClassId
        marketName
        percentage
        amount
        accumulatedYields
        benchmarkYields
        investments {
          assetName
          assetId
          percentage
          price
          amount
          securities
          completeName
          assetType
          sector
          bursatility
          investmentYield {
            assetName
            initialPrice
            currentPrice
            accumulatedYield
            weightedAccumulatedYield
          }
          comments {
            comment
          }
        }
        investmentsYield {
          assetName
          initialPrice
          currentPrice
          accumulatedYield
          weightedAccumulatedYield
        }
        sectorDistribution {
          name
          percentage
        }
        comments {
          id
          comment
        }
      }
      deuda {
        couponData {
          assetName
          frecuency
          tasa
          endData
          ytm
        }
        assetClassId
        marketName
        percentage
        amount
        investments {
          assetName
          assetId
          percentage
          price
          amount
          securities
          assetType
          rateType
          score
          couponData {
            assetName
            tasa
            frecuency
            endData
            ytm
          }
          sliderValue {
            value
          }
          comments {
            comment
          }
        }
        assetTypesDistribution {
          name
          percentage
        }
        assetRateDistribution {
          name
          percentage
        }
        scoreDistribution {
          name
          percentage
        }
        investmentsYield {
          assetName
          initialPrice
          currentPrice
          vouchersAndAmortizations
          accumulatedYield
          weightedAccumulatedYield
        }
        comments {
          id
          comment
        }
      }
      estructurados {
        assetClassId
        marketName
        percentage
        amount
        investments {
          assetName
          assetId
          percentage
          price
          amount
          securities
          assetType
          rateType
          score
          comments {
            comment
          }
        }
        assetTypesDistribution {
          name
          percentage
        }
        assetRateDistribution {
          name
          percentage
        }
        scoreDistribution {
          name
          percentage
        }
        investmentsYield {
          assetName
          initialPrice
          currentPrice
          vouchersAndAmortizations
          accumulatedYield
          weightedAccumulatedYield
        }
        comments {
          id
          comment
        }
      }
    }
  }
`

// Mutations

export const loginUser = gql`
  mutation login ($username: String!, $password: String!) {
    advisorLogin (username: $username, password: $password ){
      token
      message
      advisor {
        id
        email
        isAdmin
        name
      }
    }
  }`

export const createAdvisor = gql`
  mutation createAdvisor($name: String!, $password: String!, $email: String) {
  createUser(name: $name, password: $password, email: $email, isAdmin: false) {
    message
    returnCode
  }
}`

export const deleteAdvisor = gql`
  mutation removeAdvisor($advisorId: Int!) {
    removeUser(id: $advisorId) {
      message
      returnCode
    }
  }
`
export const deletePortfolio = gql`
  mutation removePortfolio($portfolioId: Int!) {
    removePortfolio(id: $portfolioId) {
      message
      returnCode
    }
  }
`

export const createClient = gql`
  mutation createClient ( $advisorId: Int!, $alias: String!, $email: String){
    createClient(advisorId: $advisorId, alias: $alias, email: $email) {
      client {
        id
        alias
        email
      }
      message
      returnCode
    }
  }`

export const addAsset = gql`
mutation addAsset($name: String!, $assetClassId: Int!, $price: Float!, $period: Date!) {
  createAsset(name: $name, assetClassId: $assetClassId, price: $price, period: $period) {
    asset {
      id,
      name
      price
      assetClass {
        id
        name
      }
    }
    message
  }
}`

export const createPortfolio = gql`
mutation createPortfolio( $portfolioId: Int, $advisorId: Int!, $clientId: Int!, $investmentProfileId: Int, $mode: Int!, $bType: Int!
  $contractNumber: String!, $cuttofDate: Date!, $advisorComment: String, $investments: [InvestmentInput]) {
  createPortfolio( portfolioId: $portfolioId, advisorId: $advisorId, clientId: $clientId, mode: $mode, bType: $bType, cuttofDate: $cuttofDate, contractNumber: $contractNumber,
  investments: $investments, advisorComment: $advisorComment, investmentProfileId: $investmentProfileId) {
    returnCode
    message
    portfolio {
      id
    }
  }
}
`
export const upgradePortfolio = gql`
mutation upgradePortfolio($portfolioId: Int!) {
  upgradePortfolio(idPortfolio: $portfolioId) {
    returnCode
    message
  }
}`


export const addComment = gql`
mutation addPortfolioComments( $portfolioId: Int!, $assetClassComments: [AssetClassCommentInput], $investmentComments: [InvestmentCommentInput], $portfolioComments: [PortfolioCommentInput]) {
  addPortfolioComments( portfolioId: $portfolioId, assetClassComments: $assetClassComments, investmentComments: $investmentComments, portfolioComments: $portfolioComments ) {
    returnCode
    message
  }
}`

export const sendUrl = gql`
  query sendURL($portfolioId: Int!, $email: String!) {
    sendAnalysisUrl(portfolioId: $portfolioId, email: $email) {
      msg
      returnCode
    }
  }`

export const getAllValidations = gql`
    query allValidations($email: String!, $search: String) {
        allValidations (email:$email, search:$search){
            alias
            nombre
            mailSiap
            telCelular
            mailPromotor
            cvePromotor
            codigoCliente
            
            createdAt
            updatedAt
            sendAt
            
            validated
            edited
            status
            strStatus
            
            history
            
            checkMail
            checkTel
            
            unico
        }
    }`

export const updateValidationStatus = gql`
    mutation updateValidationStatus($telCelular: String!, $mailSiap:String!, $codigoCliente: String, $alias: String, $history: String, $checked: Boolean, $mailPromotor: String) {
        updateValidationStatus (telCelular:$telCelular, mailSiap:$mailSiap, codigoCliente:$codigoCliente, alias:$alias, history:$history, checked:$checked, mailPromotor:$mailPromotor){
            message
            returnCode
            client{
                alias
                nombre
                mailSiap
                telCelular
                mailPromotor
                codigoCliente

                createdAt
                updatedAt
                sendAt

                validated
                edited
                status
                strStatus

                history

                checkMail
                checkTel
            }
        }
    }`

export const updateValidation = gql`
    mutation updateValidation($telCelular: String!, $mailSiap:String!, $codigoCliente: String!, $checkMail: Boolean!, $checkTel: Boolean!) {
        updateValidation (telCelular:$telCelular, mailSiap:$mailSiap, codigoCliente:$codigoCliente, checkMail:$checkMail, checkTel: $checkTel){
            message
            returnCode
            client{
                alias
                nombre
                mailSiap
                telCelular
                mailPromotor
                codigoCliente

                createdAt
                updatedAt
                sendAt

                validated
                edited
                status
                strStatus

                history

                checkMail
                checkTel
                unico
            }
        }
    }`

export const getCalculation = gql`
    query calculate($capital: Float!, $tasaNominal:Float, $inflacion: Float, $tasaReal: Float, 
                    $tasaIsr: Float, $tasaRet: Float, $rangoTiempo:Int) {
        calculate (capital:$capital, tasaNominal:$tasaNominal, inflacion:$inflacion, tasaReal:$tasaReal,
                   tasaIsr: $tasaIsr, tasaRet: $tasaRet, rangoTiempo: $rangoTiempo){
            message
            result
        }
    }`










// WEBPACK FOOTER //
// ./src/graphql.js